import { Component, inject } from '@angular/core';

import { Environment } from '../../../../environments/environment';
import { StateService } from '../../../services/state/state';
import { ListingDetailsCtaMiddleton } from './middleton/middleton';
import { ListingDetailsCtaVillages } from './villages/villages';

@Component({
  imports: [ListingDetailsCtaMiddleton, ListingDetailsCtaVillages],
  selector: 'app-listing-details-cta',
  styleUrl: './cta.css',
  templateUrl: './cta.html',
})
export class ListingDetailsCta {
  protected readonly stateService = inject(StateService);

  public lppPostMessage(): void {
    // if (environment.isApp) {
    //   this.stateService.notifyParentOfStateChange('HF_EVENT:LIFE_STYLE_PREVIEW', {});
    // }
    // else {
    const _origin = Environment.isApp ? 'https://www.thevillages.com' : '';
    const _url = `${_origin}/lifestyle-preview-plan`;

    const _newWindow = window.open(_url, '_blank');
    if (_newWindow) {
      _newWindow.opener = null; // Add this line to prevent the new window from having access to the opener's context for security reasons
    }
    // }
  }
}
